/**
 * Набор общих функций при регистрации пользователя
 */
import parsePhoneNumber from "libphonenumber-js";
import {_t, logError} from "../function.js";

/**
 * Данные DaData
 * @type {string}
 */
export const dadata_token = window.config.dadata.token;
export const dadata_url = window.config.dadata.url;

/**
 * Валидация телефона
 * @param id
 * @param id_region
 * @returns {E164Number|boolean}
 */
export function phone_valid(id, id_region) {
    try {

        const phone = $$(id).getValue()
        $($$(id).getNode()).removeClass("jqueryts_invalid")
        if ($($$(id).getNode()).find(".jqueryts_inp_bottom_label").length == 0) {
            $($$(id).getNode()).append(`<div class="jqueryts_inp_bottom_label" role="alert" aria-relevant="all"></div>`)
        }
        $($$(id).getNode()).find(".jqueryts_inp_bottom_label").text("")
        const phoneNumber = parsePhoneNumber(phone, $$(id_region).getValue())
        if (!phoneNumber) {
            $($$(id).getNode()).addClass("jqueryts_invalid")
            $($$(id).getNode()).find(".jqueryts_inp_bottom_label").text(_t("Проверьте корректность заполнения телефона"))
            return false
        }
        if (phoneNumber.isValid() !== true) {
            $($$(id).getNode()).addClass("jqueryts_invalid")
            $($$(id).getNode()).find(".jqueryts_inp_bottom_label").text(_t("Проверьте корректность заполнения телефона"))
            return false
        }
        $$(id).setValue(phoneNumber.nationalNumber)
        return phoneNumber.number
    } catch (e) {
        logError(e)
    }
}

/**
 * Подсказки эл. почты с использованием DaData
 * @param query
 * @returns {Promise<any>}
 */
export function get_mail(query) {
    try {

        const url = `${dadata_url}/email`;

        const options = {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": "Token " + dadata_token
            },
            body: JSON.stringify({query: query})
        }

        return fetch(url, options)
            .then(response => response.json())
            .then(result => result.suggestions)
            .catch(error => console.log("error", error));
    } catch (e) {
        logError(e)
    }
}

/**
 * Валидация эл. почты с использованием DaData
 * @param id
 * @returns {Promise<*>}
 */
export function email_valid(id) {
    try {
        $($$(id).getNode()).removeClass("jqueryts_invalid")
        if ($($$(id).getNode()).find(".jqueryts_inp_bottom_label").length == 0) {
            $($$(id).getNode()).append(`<div class="jqueryts_inp_bottom_label" role="alert" aria-relevant="all"></div>`)
        }
        $($$(id).getNode()).find(".jqueryts_inp_bottom_label").text("")
        const email = $$(id).getValue()
        return get_mail(email).then(res => {
            if (!$$(id).validate()) return false;
            if (res.length === 0) {
                $($$(id).getNode()).addClass("jqueryts_invalid")
                $($$(id).getNode()).find(".jqueryts_inp_bottom_label").text("Проверьте корректность заполнения адреса")
                return false
            }
            return true
        })
    } catch (e) {
        logError(e)
    }
}

function getField(id) {
    const $node = $($$(id).getNode());
    if ($node.find(".jqueryts_inp_bottom_label").length === 0) {
        $node.append(`<div class="jqueryts_inp_bottom_label" role="alert" aria-relevant="all"></div>`);
    }
    return $node;
}

function clearError(id) {
    const $node = getField(id);
    $node.removeClass("jqueryts_invalid");
    $node.find(".jqueryts_inp_bottom_label").text("");
    return $node;
}

function showError(id, message) {
    const $node = getField(id);
    $node.addClass("jqueryts_invalid");
    $node.find(".jqueryts_inp_bottom_label").text(message);
}

/**
 * Валидация двух паролей
 * @param id
 * @param id_re
 * @returns {boolean}
 */
export function pass_valid(id, id_re) {
    try {
        clearError(id);
        clearError(id_re);

        const passw = $$(id).getValue();
        const passw_re = $$(id_re).getValue();
        const emptyMsg = _t("Указан пустой пароль");

        if (passw.trim(" ") === "") {
            showError(id, emptyMsg);
        }
        if (passw_re.trim(" ") === "") {
            showError(id_re, emptyMsg);
        }
        if (passw.trim(" ") === "" || passw_re.trim(" ") === "") {
            return false;
        }

        if (passw.length < 6 || passw_re.length < 6) {
            const msg = _t("Пароль должен содержать минимум 6 символов");
            showError(id, msg);
            showError(id_re, msg);
            return false;
        }

        if (!/[a-zA-Zа-яА-ЯёЁ]/.test(passw) || !/\d/.test(passw)) {
            const msg = _t("Пароль должен содержать буквы и цифры");
            showError(id, msg);
            showError(id_re, msg);
            return false;
        }

        if (passw_re !== passw) {
            const msg = _t("Пароли не совпадают");
            showError(id, msg);
            showError(id_re, msg);
            return false;
        }

        return true;
    } catch (e) {
        logError(e);
    }
}

/**
 * Каждая первая буква заглавная
 * @param input
 */
export function capitalizeWords(input) {
    try {
        const words = input.split(' '); // Разделяем текст на слова
        const capitalizedWords = words.map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1); // Делаем первую букву заглавной
        });
        return capitalizedWords.join(' '); // Соединяем слова обратно в строку
    } catch (e) {
        logError(e)
    }
}